import PolicyPage from "./PolicyPage";

export default function LegalNotice() {
  return <PolicyPage testid="page-legal" policyKey="legal" />;
}
